import { createSelector } from "reselect"
import { get, chain, map } from "lodash"
import moment from "moment"
import { aggregateExposuresFactors } from "helpers/factorClassification/index"
import { getMustAggregateFactors, getStyleExposureAggregation } from "modules/portfolio-root/selectors/portfolios"
import { getModelFactorsClassification } from "selectors/modelMetadata"
import { getSelectedMetric } from "./metrics"

const getRawData0 = state => get(state, "global.data.compareFactorSensitivity0.data.model.simulation.factorSensitivity")
const getRawData1 = state => get(state, "global.data.compareFactorSensitivity1.data.model.simulation.factorSensitivity")
const getRawData2 = state => get(state, "global.data.compareFactorSensitivity2.data.model.simulation.factorSensitivity")
const getRawData3 = state => get(state, "global.data.compareFactorSensitivity3.data.model.simulation.factorSensitivity")
const getRawData4 = state => get(state, "global.data.compareFactorSensitivity4.data.model.simulation.factorSensitivity")

function getDataMap(selectedMetric, data) {
  if (!data) {
    return null
  }
  return chain(data)
    .keyBy("date")
    .mapValues(selectedMetric.value)
    .value()
}

// data has the following structure:
// [
//   {
//     date: '2018-01-01',
//     factors: [...]
//   },
//   ...,
// ]
function mapAggregatedFactors(data, mustAggregateFactors, styleExposureAggregation, factorsClassification) {
  return map(data, date => {
    let factors = get(date, "factors")
    if (!mustAggregateFactors || !factors) {
      return date
    }

    factors = aggregateExposuresFactors(factorsClassification, factors, styleExposureAggregation, "value")

    return {
      ...date,
      factors,
    }
  })
}

export const getData0 = createSelector([getRawData0, getMustAggregateFactors, getStyleExposureAggregation, getModelFactorsClassification], mapAggregatedFactors)
export const getData1 = createSelector([getRawData1, getMustAggregateFactors, getStyleExposureAggregation, getModelFactorsClassification], mapAggregatedFactors)
export const getData2 = createSelector([getRawData2, getMustAggregateFactors, getStyleExposureAggregation, getModelFactorsClassification], mapAggregatedFactors)
export const getData3 = createSelector([getRawData3, getMustAggregateFactors, getStyleExposureAggregation, getModelFactorsClassification], mapAggregatedFactors)
export const getData4 = createSelector([getRawData4, getMustAggregateFactors, getStyleExposureAggregation, getModelFactorsClassification], mapAggregatedFactors)

const getDataMap1 = createSelector([getSelectedMetric, getData1], getDataMap)
const getDataMap2 = createSelector([getSelectedMetric, getData2], getDataMap)
const getDataMap3 = createSelector([getSelectedMetric, getData3], getDataMap)
const getDataMap4 = createSelector([getSelectedMetric, getData4], getDataMap)

export const getData = createSelector(
  [getSelectedMetric, getData0, getDataMap1, getDataMap2, getDataMap3, getDataMap4],
  (selectedMetric, data, dataMap1, dataMap2, dataMap3, dataMap4) => map(data, item => ({
    date: moment(item.date),
    0: selectedMetric.value(item),
    1: dataMap1 ? get(dataMap1, item.date, 0) : undefined,
    2: dataMap2 ? get(dataMap2, item.date, 0) : undefined,
    3: dataMap3 ? get(dataMap3, item.date, 0) : undefined,
    4: dataMap4 ? get(dataMap4, item.date, 0) : undefined,
  })),
)
